import { useEffect, useState } from 'react';

export const useIsTextTruncated = <T extends HTMLElement>() => {
  const [element, setElement] = useState<T | null>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (!element) {
      return;
    }

    const measure = () => setIsTruncated(element.scrollWidth > element.clientWidth);

    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(element);

    return () => observer.disconnect();
  }, [element]);

  return { setElement, isTruncated };
};
